"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALERT_TYPE = exports.ALERT_STATUS = void 0;
var ALERT_STATUS;
(function (ALERT_STATUS) {
    ALERT_STATUS["READ"] = "READ";
    ALERT_STATUS["UNREAD"] = "UNREAD";
})(ALERT_STATUS || (exports.ALERT_STATUS = ALERT_STATUS = {}));
var ALERT_TYPE;
(function (ALERT_TYPE) {
    ALERT_TYPE["PRIORITY"] = "PRIORITY";
    ALERT_TYPE["ACKNOWLEDGE"] = "ACKNOWLEDGE";
    ALERT_TYPE["ACKNOWLEDGED"] = "ACKNOWLEDGED";
    ALERT_TYPE["REFERRAL"] = "REFERRAL";
    ALERT_TYPE["SENT_ACKNOWLEDGEMENT"] = "SENT_ACKNOWLEDGEMENT";
})(ALERT_TYPE || (exports.ALERT_TYPE = ALERT_TYPE = {}));
